<ng-container *ngFor="let item of list">
  <a [routerLink]="['/join',item.virtId]"
     class="list-group-item transition item-sub sub"
     data-parent="#menu2sub1" >
    {{item.name}}
  </a>
</ng-container>
